module.exports = __webpack_public_path__ + "img/4.b466321d.png";